import { Shippings } from 'stylewhere/api'
import { ShippingOperationConfig } from 'stylewhere/shared'

const ACTION_CODE_RETRIEVE_PRODUCTION_ORDER = 'RETRIEVE_PRODUCTION_ORDER'

export interface ProductionOrderCandidate {
  id: string
  code: string
  productionOrder: { code: string; description?: string | null }
}

export const requiresProductionOrderScan = (operation: ShippingOperationConfig): boolean => {
  return (operation.actions ?? []).some((action) => action.actionCode === ACTION_CODE_RETRIEVE_PRODUCTION_ORDER)
}

export const retrieveProductionOrderBySerial = async (
  operation: ShippingOperationConfig,
  serial: string
): Promise<ProductionOrderCandidate[]> => {
  return (await Shippings.executeAction(operation, ACTION_CODE_RETRIEVE_PRODUCTION_ORDER, {
    attributes: { serial }
  })) as ProductionOrderCandidate[]
}
